// extracted by mini-css-extract-plugin
module.exports = {"filterDropdown":"antd-pro-containers-journals-all-styles-filterDropdown","btn":"antd-pro-containers-journals-all-styles-btn","img":"antd-pro-containers-journals-all-styles-img"};